import { ImageStyle } from '../enum/EnumRepository';


export const useImageStyleJudge = () => {

  const judgeImageStyle = (imageRatio: number): ImageStyle => {
    if (!Number.isFinite(imageRatio) || imageRatio <= 0) {
      return ImageStyle.LANDSCAPE;
    }

    if (imageRatio > 1) {
      return ImageStyle.LANDSCAPE;
    } else {
      return ImageStyle.PORTRAIT;
    }
  };

  const judgeImageStyleBillboard = (imageRatio: number): ImageStyle => {
    if (imageRatio > 1) {
      // Billboard의 WorkImageForLandscape: width 80vw, max-height 90vh 기준으로 계산
      const maxScreenHeight = window.innerHeight * 0.9; // 90vh
      const maxScreenWidth = window.innerWidth * 0.8; // 80vw
      const calculatedImageHeight = maxScreenWidth / imageRatio;
      
      // 계산된 높이가 max-height(90vh)보다 작으면 LANDSCAPE, 크면 PORTRAIT 선택
      if (calculatedImageHeight < maxScreenHeight) {
        // console.log("imageStyle is LANDSCAPE");
        return ImageStyle.LANDSCAPE;
      } else {
        // console.log("imageStyle is Landscpe but height is too large, so set to PORTRAIT");
        return ImageStyle.PORTRAIT;
      }
    } else {
      // console.log("imageStyle is PORTRAIT");
      return ImageStyle.PORTRAIT;
    }
  };

  return { judgeImageStyle, judgeImageStyleBillboard };
};
